/* mineaderm özel — Kademeli sepet indirimi barı (24 Eki 2026)
   snippets/discount-tier-goal.liquid ile birlikte çalışır.
   Temanın FreeShippingGoal (assets/cart.js) sınıfıyla aynı olaylar/para biçimi kullanılır. */
(function () {
  if (customElements.get('discount-tier-goal')) return;

  class DiscountTierGoal extends HTMLElement {
    constructor() {
      super();
      this.label = this.querySelector('[data-tier-label]');
      this.progress = this.querySelector('progress-bar');
      this.rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
      this.activeCode = (this.dataset.activeCode || '').toUpperCase();
      this.shopCode = (this.dataset.shopCode || '').toUpperCase();
      if (this.activeCode && this.shopCode && this.activeCode === this.shopCode) this.rate = 1;

      // "75000:15000,150000:30000" (mağaza para birimi, kuruş) → görüntülenen para biriminde ana birim
      this.tiers = (this.dataset.tiers || '')
        .split(',')
        .map((part) => {
          const [t, r] = part.split(':');
          const threshold = Number(t), reward = Number(r);
          if (!threshold || !reward) return null;
          return { threshold: (threshold / 100) * this.rate, reward: (reward / 100) * this.rate };
        })
        .filter(Boolean)
        .sort((a, b) => a.threshold - b.threshold);

      this.onCartUpdated = (event) => {
        const cart = event.detail && event.detail.cart;
        if (cart && typeof cart.items_subtotal_price !== 'undefined') this.update(cart.items_subtotal_price);
      };
    }

    connectedCallback() {
      this.update(Number(this.dataset.cartTotal));
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }

    money(major) {
      const cents = Math.round(major * 100);
      try {
        const fmt = window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat;
        if (window.FoxTheme && FoxTheme.Currency && fmt) return FoxTheme.Currency.formatMoney(cents, fmt);
      } catch (e) { /* aşağıdaki yedek biçim */ }
      return (
        new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(major) + ' ' + (this.activeCode || 'TL')
      );
    }

    fill(template, vars) {
      let out = template || '';
      Object.keys(vars).forEach((k) => { out = out.split('[' + k + ']').join(vars[k]); });
      return out;
    }

    update(amountCents) {
      amountCents = Number(amountCents) || 0;
      if (!this.tiers.length) { this.classList.add('hidden'); return; }
      this.classList.toggle('hidden', amountCents <= 0);

      const cart = amountCents / 100;
      const top = this.tiers[this.tiers.length - 1];
      let reached = null, next = null;
      for (const tier of this.tiers) {
        if (cart >= tier.threshold) reached = tier; else if (!next) next = tier;
      }

      const percent = Math.min((cart / top.threshold) * 100, 100);
      if (this.progress) {
        this.progress.style.setProperty('--percent', percent + '%');
        this.progress.dataset.value = Math.min(cart, top.threshold); // temanın ProgressBar sınıfı 100% üstünü kırpmıyor
        this.progress.dataset.max = top.threshold;
      }

      let html;
      if (!next) {
        html = this.fill(this.dataset.textDone, { reward_done: this.money(reached.reward) });
      } else if (reached) {
        html = this.fill(this.dataset.textMid, {
          reward_done: this.money(reached.reward),
          reward: this.money(next.reward),
          left: this.money(next.threshold - cart),
        });
      } else {
        html = this.fill(this.dataset.textNext, {
          reward: this.money(next.reward),
          left: this.money(next.threshold - cart),
        });
      }
      if (this.label) this.label.innerHTML = html;

      this.classList.toggle('discount-tier-goal--done', !next);
      this.classList.toggle('discount-tier-goal--partial', !!reached && !!next);
      this.querySelectorAll('[data-tier-chip]').forEach((chip, i) => {
        chip.classList.toggle('is-reached', !!this.tiers[i] && cart >= this.tiers[i].threshold);
      });
    }
  }

  customElements.define('discount-tier-goal', DiscountTierGoal);
})();
